import { usePermissions } from '@/features/auth/access-control/context/PermissionsProvider';
import * as React from 'react';

type Rule = { anyOf: string[] } | { allOf: string[] } | { not: string[] };

function passes(rule: Rule | undefined, perms: ReturnType<typeof usePermissions>) {
  if (!rule) return true;

  if ('anyOf' in rule) return perms.canAny(rule.anyOf);
  if ('allOf' in rule) return perms.canAll(rule.allOf);
  if ('not' in rule) return !perms.canAny(rule.not);

  return true;
}

export function useCan(rule?: Rule) {
  const perms = usePermissions();
  // memo not strictly required, but helps avoid recompute noise
  return React.useMemo(() => passes(rule, perms), [perms, rule]);
}

export function Can({
  rule,
  fallback = null,
  children,
}: {
  rule?: Rule;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}) {
  const perms = usePermissions();
  return passes(rule, perms) ? <>{children}</> : <>{fallback}</>;
}
